import { render, staticRenderFns } from "./NaturalComfort.vue?vue&type=template&id=2c89fee6&scoped=true"
import script from "./NaturalComfort.vue?vue&type=script&lang=js"
export * from "./NaturalComfort.vue?vue&type=script&lang=js"
import style0 from "./NaturalComfort.vue?vue&type=style&index=0&id=2c89fee6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89fee6",
  null
  
)

export default component.exports